import { Capacitor } from "@capacitor/core";

const SERVICE_WORKER_URL = "/firebase-messaging-sw.js";

const canUseServiceWorker = () =>
  typeof window !== "undefined" &&
  !Capacitor.isNativePlatform() &&
  "serviceWorker" in navigator &&
  (window.isSecureContext || window.location.hostname === "localhost");

export async function registerMarankooServiceWorker() {
  if (!canUseServiceWorker()) return null;

  try {
    const registration = await navigator.serviceWorker.register(SERVICE_WORKER_URL, {
      scope: "/",
      updateViaCache: "none",
    });

    return registration;
  } catch (error) {
    console.error("Service Worker registration failed:", error);
    return null;
  }
}

export async function getMarankooServiceWorkerRegistration() {
  if (!canUseServiceWorker()) return null;

  const existing = await navigator.serviceWorker.getRegistration("/");
  if (existing) return existing;

  const registered = await registerMarankooServiceWorker();
  if (!registered) return null;

  try {
    return await navigator.serviceWorker.ready;
  } catch (_) {
    return registered;
  }
}

export { canUseServiceWorker };
